import { gql } from "@apollo/client";

/**
 * Contact details a buyer was asked to confirm and has not.
 *
 * Authenticated and shop-scoped, unlike the public order lookup: every row carries a phone
 * number and a home address, so the resolver proves shop ownership before returning any.
 */
export const CONTACT_DRAFTS_PENDING = gql`
  query ContactDraftsPending($shopId: ID!, $onlyOverdue: Boolean, $limit: Int, $offset: Int) {
    contactDraftsPending(shopId: $shopId, onlyOverdue: $onlyOverdue, limit: $limit, offset: $offset) {
      total
      data {
        id
        userFbId
        parsedPhone
        phoneConfidence
        rawAddressText
        resolutionStatus
        resolved {
          provinceName
          districtName
          village
          branch
          carrierName
        }
        summarySentAt
        createdAt
      }
    }
  }
`;
